import styled from 'styled-components';

const StyledTextArea = styled.textarea`
  width: 100%;
  border-radius: ${({ theme }) => theme.shape.borderRadius * 3}px;
  padding: ${({ theme }) => theme.spacing(2)};
  font-family: ${({ theme }) => theme.typography.fontFamily};
  resize: none;
  border: 1.5px solid ${({ theme }) => theme.palette.backdrop.dark};
  &:focus {
    border: 1.5px solid ${({ theme }) => theme.palette.primary.main};
    outline: none;
  }
  background-color: ${({ theme }) => theme.palette.backdrop.light};
  color: ${({ theme }) => theme.palette.backdrop.contrastText};
`;

export { StyledTextArea };
